import type {
  WordLevelsPack,
  WordManifest,
  WordTopic,
  WordVocabulary,
} from './types.js';

export interface LoadedWordTopic {
  topic: WordTopic;
  vocabulary: WordVocabulary;
  levels: WordLevelsPack;
}

export async function loadWordManifest(baseUrl = '/data/words'): Promise<WordManifest> {
  const response = await fetch(`${baseUrl}/manifest.json`);
  if (!response.ok) {
    throw new Error(`Failed to load word manifest: ${response.status}`);
  }
  return response.json() as Promise<WordManifest>;
}

export async function loadWordTopic(
  topic: WordTopic,
  baseUrl = '/data/words',
): Promise<LoadedWordTopic> {
  if (!topic.vocabularyFile || !topic.levelsFile) {
    throw new Error(`Topic ${topic.id} has no content files`);
  }

  const [vocabRes, levelsRes] = await Promise.all([
    fetch(`${baseUrl}/${topic.vocabularyFile}`),
    fetch(`${baseUrl}/${topic.levelsFile}`),
  ]);

  if (!vocabRes.ok) throw new Error(`Failed to load vocabulary: ${vocabRes.status}`);
  if (!levelsRes.ok) throw new Error(`Failed to load levels: ${levelsRes.status}`);

  const [vocabulary, levels] = await Promise.all([
    vocabRes.json() as Promise<WordVocabulary>,
    levelsRes.json() as Promise<WordLevelsPack>,
  ]);

  return { topic, vocabulary, levels };
}

export function getWordLevelById(pack: WordLevelsPack, id: string) {
  return pack.levels.find((l) => l.id === id);
}
